import React, { useContext, useEffect, useState } from 'react';
import { UserRole } from '../../types/lms.types';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { message } from 'antd';
import { NecttosContext } from '../../../WebControlCenter/context/NecttosContext';

interface ViewSubmissionProps {
  submission?: any;
  onBack?: () => void;
  userRole: UserRole;
}

const ViewSubmission: React.FC<ViewSubmissionProps> = ({ submission, onBack, userRole }) => {
  //const { studentId } = useContext(NecttosContext);
  const [submi, setSubmission] = useState<any[]>([]);
  const [mark, setMark] = useState<number>(0);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  useEffect(() => {
    const loadData = async () => {
      if (!submission || !submission._id) return;

      const instance = await getAxiosTokenInstance();

      try {
        if (userRole === 'student') {
          const resp = await instance.get('/college/lms/submissions/getSubmission', {
            params: {
              assignmentId: submission._id,
              category: submission.category,
              studentId:"NST-24CC30EF1B6F-4CA8-A416-0C79605B15DB",
              type: submission.type,
            },
          });

          if (resp?.data?.data) {
            console.log(resp.data.data)
            setSubmission([resp.data.data]); // single submission as array
          }
        } else if (userRole === 'teacher') {
          const resp = await instance.get('/college/lms/submissions/getAllSubmission', {
            params: {
              assignmentId: submission._id,
              type: submission.type,
              category: submission.category,
            },
          });

          if (Array.isArray(resp?.data?.data)) {
            setSubmission(resp.data.data);
          }
        }
      } catch (error) {
        console.error('Failed to fetch submission data:', error);
        message.error('Unable to load submissions.');
      }
    };

    loadData();
  }, [submission, userRole]);

  const handleMarkSubmit = async (id: string) => {
    if (!id) return;

    const instance = await getAxiosTokenInstance();
    setIsSubmitting(true);

    try {
      const resp = await instance.post('/college/lms/submissions/markSubmission', {
        mark,
        submissionId: id,
      });

      message.success('Mark added successfully!');
    } catch (err) {
      console.error(err);
      message.error('Failed to add the mark. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 bg-white shadow-lg rounded-md max-w-4xl mx-auto">
      <button
        onClick={onBack}
        className="mb-6 inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
      >
        ← Back
      </button>

      <h2 className="text-3xl font-bold text-gray-900 mb-6">Submission Details</h2>

      {submi.length > 0 ? (
        submi.map((submissionItem: any, index: number) =>
          submissionItem.type == 'assignment' ? (
            <div key={index} className="space-y-6 mb-8">
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800">Submission Overview</h3>
                <div className="grid grid-cols-2 gap-4 mt-4 text-sm text-gray-600">
                  <div>
                    <strong>Category:</strong> {submissionItem.category}
                  </div>
                  <div>
                    <strong>Submission Date:</strong>{' '}
                    {submissionItem.submittedAt
                      ? new Date(submissionItem.submittedAt).toLocaleString()
                      : '—'}
                  </div>
                  <div>
                    <strong>Mark:</strong> {submissionItem.mark ?? '—'}
                  </div>
                  <div>
                    <strong>File Type:</strong> {submissionItem.fileType ?? '—'}
                  </div>
                  <div>
                    <strong>File Size:</strong>{' '}
                    {submissionItem.fileSize ? `${Math.round(submissionItem.fileSize / 1024)} KB` : '—'}
                  </div>
                </div>

                <h3 className="text-lg font-semibold text-gray-800 mt-6">Student Information</h3>
                <div className="grid grid-cols-2 gap-4 mt-4 text-sm text-gray-600">
                  <div>
                    <strong>Student Name:</strong> {submissionItem.studentName ?? '—'}
                  </div>
                  <div>
                    <strong>Submitted By:</strong> {submissionItem.submittedBy ?? '—'}
                  </div>
                  
                    {submissionItem.category == 'group' && (
                        <div className="col-span-2">
                          <strong>Group Members:</strong>{' '}
                    {Array.isArray(submissionItem.studentNames) && submissionItem.students.length > 0
                      ? submissionItem.studentNames.join(', ')
                      : 'No students in this group'}
                  </div>
                    )}
                    
                </div>

                <h3 className="text-lg font-semibold text-gray-800 mt-6">Submission Details</h3>
                <div className="mt-4 text-sm text-gray-600">
                  <strong>Description:</strong> {submissionItem.description ?? '—'}
                </div>
                <div className="mt-4">
                  <a
                    href={submissionItem.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                  >
                    Download File
                  </a>
                </div>

                {!submissionItem.isCorrected && userRole === 'teacher' && (
                  <div className="mt-6">
                    <h4 className="text-lg font-semibold text-gray-800">Add Mark</h4>
                    <div className="mt-4 text-sm text-gray-600">
                      <label htmlFor="mark" className="block mb-2">
                        Mark:
                      </label>
                      <input
                        id="mark"
                        type="number"
                        min="0"
                        max="100"
                        onChange={(e) => {
                          const value = e.target.value;
                          setMark(value === '' ? 0 : Number(value));
                        }}
                        className="p-2 border border-gray-300 rounded-md w-full"
                      />
                    </div>
                    <div className="mt-4">
                      <button
                        onClick={() => handleMarkSubmit(submissionItem._id)}
                        disabled={isSubmitting}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-md ${
                          isSubmitting ? 'bg-gray-500' : 'bg-blue-600 hover:bg-blue-700'
                        }`}
                      >
                        {isSubmitting ? 'Submitting...' : 'Submit Mark'}
                      </button>
                    </div>
                  </div>
                )}

                <h3 className="text-lg font-semibold text-gray-800 mt-6">Correction Status</h3>
                <div className="mt-4 text-sm text-gray-600">
                  <strong>Corrected:</strong> {submissionItem.isCorrected ? 'Yes' : 'No'}
                </div>
              </div>
            </div>
          ) :<div key={index} className="space-y-6 mb-8">
  <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 shadow-sm">
    <h3 className="text-xl font-semibold text-gray-800 mb-4">Quiz Submission Overview</h3>

    <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">

      <div><strong>Student:</strong> {submissionItem.studentName}</div>
      <div><strong>Submitted At:</strong> {submissionItem.submittedAt ? new Date(submissionItem.submittedAt).toLocaleString() : '—'}</div>
      <div><strong>Mark:</strong> {submissionItem.mark ?? '—'}</div>
      <div><strong>Corrected:</strong> {submissionItem.isCorrected ? 'Yes' : 'No'}</div>
    </div>

    {Array.isArray(submissionItem.answers) && submissionItem.answers.length > 0 && (
      <div className="mt-6">
        <h4 className="text-lg font-semibold text-gray-800 mb-2">Answers</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">
          {submissionItem.answers.map((ans: any, idx: number) => (
            <div key={idx} className="p-4 bg-white border border-gray-300 rounded-md shadow-sm">
              <div><strong>Question no:</strong> {idx+1}</div>
              <div><strong>Selected Option:</strong> {ans.selectedOption ?? '—'}</div>
              <div><strong>Correct:</strong> {ans.isCorrect ? 'Yes' : 'No'}</div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
</div>

        )
      ) : (
        <p>No submission data available.</p>
      )}
    </div>
  );
};

export default ViewSubmission;
